import React from 'react';
import Heading from '../../../generic-components/Heading';
import { ProfilePlanPromotion } from '../../profile/components/ProfilePlanPromotion';
import { ReactComponent as ScheduleCIcon } from '../../../assets/icons/svg/large-icons/ic-large-form-schedule-c.svg';
import { useStore } from '../../../store';

export const UpgradeIntro = () => {
  const summaryData = useStore((state) => state.summary);
  return (
    <div className='bg-bw02 h-screen pl-[72px] pt-[92px] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn'>
      <div className='flex flex-col h-full fadeIn bg-bw00s rounded-[8px]'>
        <Heading
          title='Schedule C'
          className='py-[16px] px-[24px] border-b border-b-bw03 font-metricRMedium text-[20px] text-bw08'
        />
        <div className='flex flex-col w-full h-full items-center justify-center'>
          <ScheduleCIcon className='mb-[16px]' />
          <Heading
            title='Upgrade Now to generate your Schedule C'
            className='font-metricRMedium text-[24px] text-bw08 mb-[14px]'
          />
          <Heading
            title='Create an autofilled Schedule C form (part of the 1040 form) with your account information'
            className='font-metricR text-[16px] w-[450px] text-center text-bw07 mb-[30px]'
          />
          <ProfilePlanPromotion
            customTitle='Upgrade Now'
            planType={summaryData.customerProfileInfo.customerProfile}
            shouldAppearAsButton
          />
        </div>
      </div>
    </div>
  );
};
